module.exports = __webpack_public_path__ + "static/amare_img_28_h-28952229e5d6d9fee8f19d788c379026.jpg";